import { BehaviorSubject, Observable } from 'rxjs';
import networkBoundResource from '@/api/networkBoundResource';
import unwrapApiWrapper from '@/api/unwrapApiWrapper';
import Resource from '@/api/Resource';
import User from '@/api/mjegb/User';
import HttpClient from '@/util/http/HttpClient';
import ApiWrapper from '@/api/ApiWrapper';
import { switchMap } from 'rxjs/operators';

export default class UserRepository {
    private readonly client: HttpClient;
    private readonly baseUrl: string;
    private readonly logoutEndpoint: string;

    public constructor(client: HttpClient, apiEndpoint: string, logoutEndpoint: string) {
        this.client = client;
        this.baseUrl = apiEndpoint;
        this.logoutEndpoint = logoutEndpoint;
    }

    public getSelf(): Observable<{ name: string } | null> {
        return this.client.get('self', { baseUrl: this.baseUrl });
    }

    public findCurrent(): Observable<Resource<User>> {
        const observable = this.getSelf().pipe(
            switchMap((user) => {
                if (user) {
                    const observable = this.client.get<ApiWrapper<User>>('user/current', { baseUrl: this.baseUrl });
                    return unwrapApiWrapper(observable);
                }
                return new BehaviorSubject(null).asObservable();
            }),
        );
        return networkBoundResource(observable);
    }

    public logout(): Observable<Resource<{ logoutUrl: string }>> {
        const observable = this.client.post<{ logoutUrl: string }>(this.logoutEndpoint);
        return networkBoundResource(observable);
    }
}
